'use client';

import { useIsMobile } from '@/hooks/use-mobile';
import { cn } from '@/lib/utils';
import { Tooltip, TooltipContent, TooltipTrigger } from './tooltip';

type HoverTooltipTextProps = {
    text: string;
    tooltipText?: string;
    className?: string;
};

export default function HoverTooltipText({ text, tooltipText, className }: HoverTooltipTextProps) {
    const isMobile = useIsMobile();
    const textElement = <span className={cn(tooltipText && !isMobile && 'cursor-help', className)}>{text}</span>;

    if (!tooltipText || isMobile) {
        return textElement;
    }

    return (
        <Tooltip>
            <TooltipTrigger asChild>{textElement}</TooltipTrigger>
            <TooltipContent
                className="max-w-[300px] bg-[#0E0E0E] text-white p-[15px]"
                customArrowClass="bg-[#0E0E0E] fill-[#0E0E0E]"
            >
                <p>{tooltipText}</p>
            </TooltipContent>
        </Tooltip>
    );
}
